var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatementWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61255 7.29268C1.31958 6.94586 1.31958 6.43793 1.61255 6.09111C2.40647 5.15186 4.17169 3.44189 6.50008 3.44189C8.82847 3.44189 10.5937 5.15186 11.3876 6.09111C11.6806 6.43793 11.6806 6.94586 11.3876 7.29268C10.5937 8.23193 8.82847 9.94189 6.50008 9.94189C4.17169 9.94189 2.40647 8.23193 1.61255 7.29268Z",
    stroke: "white",
    strokeWidth: 1.11429,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4999 8.08475C7.78198 8.08475 8.82132 7.04541 8.82132 5.76332C8.82132 4.48123 7.78198 3.44189 6.4999 3.44189C5.21781 3.44189 4.17847 4.48123 4.17847 5.76332C4.17847 7.04541 5.21781 8.08475 6.4999 8.08475Z",
    stroke: "white",
    strokeWidth: 1.11429,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatementWhite);
export default __webpack_public_path__ + "static/media/statementWhite.f503cab80a41d53dba07cb246271b324.svg";
export { ForwardRef as ReactComponent };